<app-header></app-header>
<div class="container margin-top-70">
  <div class="container margin-top-70" style="padding: 0px;">
    <div class="row">
      <div class="col-md-6 mt-6 mx-auto">
        <table class="table table-bordered">
          <tbody>
            <tr>
              <td>User Id</td>
              <td>
                <app-drop-down-single-select
                  [DropDownOptions]="selectStatusTypeDropDownOptions"
                  (typeSelectedChanged)="updateSelectedType($event)"
                  [name]="'userId'"
                ></app-drop-down-single-select>
              </td>
              <td>
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="selectedUserId"
                  name="userId"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-md-6 mt-6 mx-auto">
        <table class="table table-bordered">
          <tbody>
            <tr>
              <td>Product Id</td>
              <td>
                <app-drop-down-single-select
                  [DropDownOptions]="selectStatusTypeDropDownOptions"
                  (typeSelectedChanged)="updateSelectedType($event)"
                  [name]="'productID'"
                ></app-drop-down-single-select>
              </td>
              <td>
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="selectedProductID"
                  name="productID"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div></div>

  <div class="container">
    <div class="d-grid gap-2 d-md-flex justify-content-md-end">
      <button
        type="submit"
        class="btn btn-primary btn-pkt"
        (click)="searchProduct()"
      >
        Search
        <i class="bi bi-search ps-1"></i>
      </button>
      <button
        type="submit"
        class="btn btn-pkt btn-success ms-1"
        (click)="downloadReport()"
      >
        Download
        <i class="bi bi-download ps-1"></i>
      </button>
    </div>
  </div>
  <div class="container table-responsive">
    <table
      class="table table-hover table-bordered table-striped mt-2 pkt-table-style"
    >
      <thead class="thead-dark">
        <tr>
          <th scope="col" style="width: 15%;">Product ID</th>
          <th scope="col" style="width: 10%;">Date Changed</th>

          <th scope="col" style="width: 10%;">Working Title</th>
          <th scope="col" style="width: 20%;">Publisher</th>

          <th scope="col" style="width: 20%;">Current OSD</th>
          <th scope="col" style="width: 15%;">Change By</th>
          <th scope="col" style="width: 15%;">Before Change</th>
          <th scope="col" style="width: 15%;">After Change</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let product of products">
          <tr *ngFor="let log of product.osd_log">
            <td>{{product.part_number}}</td>
            <td>{{log.date_created}}</td>
            <td>{{product.name}}</td>
            <td>
              {{product.publisher.length > 0 ? product.publisher[0].name : ''}}
            </td>
            <td>{{log.after_value_string}}</td>
            <td>
              {{log?.created_by?.first_name}} {{log?.created_by?.last_name}}
            </td>
            <td>{{log.before_value_string}}</td>
            <td>{{log.after_value_string}}</td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>

  <div class="container">
    <app-pagination
      [maxSize]="maxSize"
      [pageSize]="pageSize"
      [collectionSize]="totalProducts"
      (pageChanged)="updatePageData($event)"
    ></app-pagination>
  </div>
</div>
